
<template>
<!-- eslint-disable -->
<transition :enter-active-class="transition.enter" :leave-active-class="transition.leave">
  <div v-show="isActive" class="snackbar" :class="[type,position]">
    <p class="text">{{ message }}</p>
    <div v-if="actionText" class="action" @click="action" :class="type">
      <button class="button is-dark">{{ actionText }}</button>
    </div>
    <div v-if="actionText" class="action" @click="cierra" :class="type">
      <button class="button is-dark">Cerrar</button>
    </div>
  </div>
</transition>
</template>

<script>
/* eslint-disable */
import NoticeMixin from './NoticeMixin.js'

export default {
  name: 'CustomSnackbar',
  mixins: [NoticeMixin],
  props: {
    actionText: {
      type: String,
      default: 'OK'
    },
    onAction: {
      type: Function,
      default: () => {}
    },
    indefinite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newDuration: this.duration || 3500
    }
  },
  methods: {
    /**
     * Click listener.
     * Call action prop before closing (from Mixin).
     */
    action() {
      this.onAction()
      this.close()
    },
    cierra() {
      this.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UI/CustomSnackbar/CustomSnackbar.vue